import {useEffect, useState} from 'react';
import { jsxActions as fetchEntitiesActions } from '../../../../actions/FetchEntities/fetchEntitiesActions.js';
import { jsxActions as createMaterialTypeFormActions} from '../../../../actions/Administration/MatSettingsPage/createMaterialTypeFormActions.js';
import useRedux from 'infrastructure/js/hooks/useRedux';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import MaterialTypeForm from './materialTypeForm';

const getState = (state) => {
  return {
    formData: state.administration.getIn(['matSettingsPage', 'createMaterialTypeForm']),
    sLoggedInUser : state.login.get('loggedInUser'),
  }
}

const allActions = {
  actions: createMaterialTypeFormActions,
  fetchEntitiesActions: fetchEntitiesActions,
};


function MaterialTypeFormWrapper (props) {
  const { state, actions } = useRedux(allActions, getState);
  const { formData, loading } = state;

  const [initialized, setInitialized] = useState(false);
  const [item, setItem] = useState(null);

  useEffect(() => {
    let materialTypeId = props.match.params.materialTypeId;
    if (materialTypeId) {
      actions.actions.fetchFormItem(+materialTypeId).then(data => {
        if (data) {
          setItem(data);
          setInitialized(true);
        }
        else {
          props.history?.goBack();
        }
      })
    }
    else {
      setInitialized(true);
    }

    return () => {
      actions.actions.clearFormData();
    }
  }, []);




  return  initialized && !loading  ?

    <MaterialTypeForm initialData={item}
                 sData={formData}
                 actions={{...actions.actions, ...actions.fetchEntitiesActions}}
                 {...props } /> :
    <Overlay.Loading />
}

export default MaterialTypeFormWrapper;
